import { useQuery } from "react-query";
import { z } from "zod";
import { loggedInApiCall } from "src/api/axiosClient/userApi";
import { PuckPage } from "./useCreatePuckPage";

export const getPuckPageQueryKey = "getPuckPage";

type GetPuckPageOptions = {
    slug: string;
    enabled?: boolean;
};

export const useGetPuckPage = (options: GetPuckPageOptions) => {
    const validatedOptions = GetPuckPageOptionsSchema.parse(options);
    const { slug, enabled = true } = validatedOptions;

    const url = `/api/cms/puck/page/${slug}`;

    const query = useQuery({
        queryKey: [getPuckPageQueryKey, slug],
        enabled: enabled && slug !== "",
        queryFn: async () => {
            const response = await loggedInApiCall.get<PuckPage>(url);

            return PuckPageResponseSchema.parse(response.data);
        },
        onError: (error: unknown) => {
            if (error instanceof Error) {
                console.error(`Error fetching page (${slug}):`, error.message);
            } else {
                console.error(`Error fetching page (${slug}):`, error);
            }
        },
    });

    return {
        page: query.data,
        ...query,
    };
};

export const GetPuckPageOptionsSchema: z.ZodSchema<GetPuckPageOptions> = z.object({
    slug: z.string(),
    enabled: z.boolean().optional(),
});

export const PuckPageResponseSchema: z.ZodSchema<PuckPage> = z.object({
    slug: z.string(),
    title: z.string(),
    content: z.string(),
    locale: z.string(),
    createdAt: z.string(),
    updatedAt: z.string(),
});
